module.exports = __webpack_public_path__ + "img/avatar-s-5.99691e54.jpg";